import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/Jobs/Banner';
import Global from '../Components/Pages/Jobs/Global';
import Why from '../Components/Pages/Jobs/Why';
import Header from '../Components/Shared/Header/Header';
import Customer from '../Components/Shared/Customers/Customers';
import Jobs1 from '../Components/Pages/Jobs/Jobs';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function Jobs(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Why />
        <Global />
        <Customer />
        <Jobs1 />
        <Start />
        <Footer />
        </>
    )
};
export default Jobs;